// 课程数据存储
const state = {
  defaultCourseCover: [ //默认课程cover图片
    `this.src="${require("@/assets/course/course-cover01.jpg")}"`,
    `this.src="${require("@/assets/course/course-cover02.jpg")}"`,
    `this.src="${require("@/assets/course/course-cover03.jpg")}"`,
    `this.src="${require("@/assets/course/course-cover04.jpg")}"`,
    `this.src="${require("@/assets/course/course-cover05.jpg")}"`,
  ],
  markMap: { //课程状态Map (课程详情右上角)
    // 同步课
    2: {
      text: "进入直播",
      class: "",
      lessonStatus: {
        text: "直播中",
        class: "btnconduct"
      },
    },
    3: {
      text: "进入直播",
      class: "btn-no",
      lessonStatus: {
        text: "未开始",
        class: ""
      },
    },
    // 异步课
    11: {
      text: "开始学习",
      class: "",
      lessonStatus: {
        text: "已开放",
        class: "finish"
      },
    },
    12: {
      text: "开始学习",
      class: "btn-no",
      lessonStatus: {
        text: "未开放",
        class: "finish"
      },
    },
  },

};

const mutations = {};

export default {
  state,
  mutations
}